var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"app":""}},[_c('v-col',{staticClass:"text-center pa-0",attrs:{"cols":"12"}},[_vm._v(" Powered by "),_c('a',{attrs:{"href":"https://institut.digital","target":"_blank"}},[_vm._v(" institut.digital")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }